import { PayloadOptions } from "./handbookFormPayload";
import { RefFieldKeys } from "./handbookFormValues";

/**
 * Набор полей у справочника выводится из данных, поэтому форма собирается
 * из флагов: какие поля показать и под какими именами лежат ссылки.
 */
export type HandbookFormProps = {
  open: boolean;
  loading?: boolean;
  initial?: any | null;
  onCancel: () => void;
  onSubmit: (payload: any) => void;
  showAlias?: boolean;
  showDivision?: boolean;
  showDataSourceStatus?: boolean;
  showCategory?: boolean;
  showType?: boolean;
  showUnitMeasurement?: boolean;
  showOrder?: boolean;
  showThresholdPerM2?: boolean;
  showCrop?: boolean;
  showRegion?: boolean;
  showBik?: boolean;
  showBank?: boolean;
  showAddress?: boolean;
  showDescriptionRu?: boolean;
  showDescriptionKy?: boolean;
  categoryFieldKey?: string | null;
  typeFieldKey?: string | null;
  unitMeasurementFieldKey?: string | null;
  cropFieldKey?: string | null;
  bankFieldKey?: string | null;
  /** Страницы «Все справочники» и «Все сервисы» дополнительно правят код записи. */
  isAllServices?: boolean;
  isAllHandbooks?: boolean;
  isTerritorialUnit?: boolean;
  isAgroCredit?: boolean;
  serviceOptions?: Array<{ value: any; label: any }>;
  /**
   * Обязательные поля из swagger-схемы справочника — имена такие же, как в теле
   * запроса (`animalTypeId`). Если не передано, обязательны только код и названия.
   */
  requiredFields?: readonly string[];
};

/** Проверка обязательности по имени поля в теле запроса. */
export const makeIsRequired =
  (requiredFields: readonly string[] = ["nameRu", "nameKy", "code"]) =>
  (payloadKey: string | null | undefined): boolean =>
    !!payloadKey && requiredFields.includes(payloadKey);

/** Имена полей-ссылок в виде, который ждут сборщики значений и payload. */
export const toRefFieldKeys = (p: HandbookFormProps): RefFieldKeys => ({
  category: p.categoryFieldKey,
  type: p.typeFieldKey,
  crop: p.cropFieldKey,
  bank: p.bankFieldKey,
  unitMeasurement: p.unitMeasurementFieldKey,
});

export const toPayloadOptions = (
  p: HandbookFormProps,
  refFieldKeys: RefFieldKeys,
): PayloadOptions => ({
  ...refFieldKeys,
  initialId: p.initial?.id,
  isAllServices: p.isAllServices,
  isAllHandbooks: p.isAllHandbooks,
  showAlias: p.showAlias,
  showAddress: p.showAddress,
  showDescriptionRu: p.showDescriptionRu,
  showDescriptionKy: p.showDescriptionKy,
  showBik: p.showBik,
  showDivision: p.showDivision,
  showOrder: p.showOrder,
  showThresholdPerM2: p.showThresholdPerM2,
  showDataSourceStatus: p.showDataSourceStatus,
  showCategory: p.showCategory,
  showCrop: p.showCrop,
  showBank: p.showBank,
  showRegion: p.showRegion,
  showType: p.showType,
  showUnitMeasurement: p.showUnitMeasurement,
});
